import "./body.scss"; import "./news_list_module__heading.scss"

